import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/account-retailer-supplier-location`;

export const accountRetailerSupplierLocationService = {
    listRetailerSupplierLocations: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list-retailer-supplier-locations`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
}
